export enum PaperConsentOptionid {
  HHC_ESIGNATURE = 'helixHostedConsent',
  PAPER_CONSENT = 'paperWetSignature',
  PARTNER_HOSTED_CONSENT = 'partnerHostedConsent',
}
